(function () {
  const IMAGE_CLIPS = {
    right: {
      hidden: "polygon(107% -1%, 220% -1%, 220% 101%, 114% 101%)",
      out: "polygon(-120% -1%, -7% -1%, -7% 101%, -120% 101%)",
    },
    left: {
      hidden: "polygon(-120% -1%, -7% -1%, -14% 101%, -120% 101%)",
      out: "polygon(107% -1%, 220% -1%, 220% 101%, 107% 101%)",
    },
    visible: "polygon(-1% -1%, 101% -1%, 101% 101%, -1% 101%)",
  };

  const IMAGE_REVEAL_DURATION = 1;

  const isForwardTransition = ({
    swipeDirection,
    activeIndex,
    previousIndex,
    totalSlides,
  }) => {
    if (swipeDirection === "next") {
      return true;
    }

    if (swipeDirection === "prev") {
      return false;
    }

    const delta = activeIndex - previousIndex;
    if (totalSlides > 1 && Math.abs(delta) === totalSlides - 1) {
      return delta < 0;
    }

    return delta > 0;
  };

  const setupStaticContent = (section) => {
    const imageSwiper = section.querySelector(".product-slider__image-swiper");
    if (!imageSwiper) {
      return;
    }
  };

  const setupImageMasks = (section) => {
    const slides = section.querySelectorAll(
      ".product-slider__image-swiper .swiper-slide"
    );

    slides.forEach((slide) => {
      const box = slide.querySelector(".product-slider__image-slider__box");
      if (!box || box.querySelector(":scope > .product-slider__image-mask")) {
        return;
      }

      const contentWrapper = box.querySelector(
        ":scope > .product-slider__content-wrapper"
      );
      const mediaNodes = Array.from(box.children).filter(
        (node) =>
          node !== contentWrapper &&
          (node.tagName === "IMG" ||
            node.tagName === "SVG" ||
            node.tagName === "VIDEO" ||
            node.classList.contains("placeholder-svg"))
      );

      if (!mediaNodes.length) {
        return;
      }

      const mask = document.createElement("div");
      mask.className = "product-slider__image-mask";
      box.insertBefore(mask, box.firstChild);

      mediaNodes.forEach((node) => {
        mask.appendChild(node);
      });
    });
  };

  const initImageRevealAnimation = (section, initialIndex = 0) => {
    if (typeof gsap === "undefined") {
      return null;
    }

    const slides = Array.from(
      section.querySelectorAll(".product-slider__image-swiper .swiper-slide")
    );
    const masks = slides
      .map((slide) => slide.querySelector(":scope .product-slider__image-mask"))
      .filter(Boolean);

    if (masks.length <= 1 || masks.length !== slides.length) {
      return null;
    }

    const applyLayering = (activeIndex, previousIndex) => {
      slides.forEach((slide, index) => {
        const isVisibleLayer = index === activeIndex || index === previousIndex;

        if (index === activeIndex) {
          slide.style.zIndex = "2";
        } else if (index === previousIndex) {
          slide.style.zIndex = "1";
        } else {
          slide.style.zIndex = "0";
        }

        slide.style.opacity = isVisibleLayer ? "1" : "0";
        slide.style.visibility = isVisibleLayer ? "visible" : "hidden";
      });
    };

    masks.forEach((mask, index) => {
      gsap.set(mask, {
        clipPath:
          index === initialIndex
            ? IMAGE_CLIPS.visible
            : IMAGE_CLIPS.right.hidden,
      });
    });

    applyLayering(initialIndex, -1);

    return ({ activeIndex, previousIndex, moveForward }) => {
      if (
        activeIndex === previousIndex ||
        activeIndex < 0 ||
        previousIndex < 0 ||
        !masks[activeIndex] ||
        !masks[previousIndex]
      ) {
        return;
      }

      const incomingStart = moveForward
        ? IMAGE_CLIPS.right.hidden
        : IMAGE_CLIPS.left.hidden;
      const outgoingEnd = moveForward
        ? IMAGE_CLIPS.left.out
        : IMAGE_CLIPS.right.out;

      applyLayering(activeIndex, previousIndex);

      gsap.killTweensOf([masks[activeIndex], masks[previousIndex]]);
      gsap.set(masks[activeIndex], { clipPath: incomingStart });
      gsap.set(masks[previousIndex], { clipPath: IMAGE_CLIPS.visible });

      gsap.to(masks[activeIndex], {
        clipPath: IMAGE_CLIPS.visible,
        duration: IMAGE_REVEAL_DURATION,
        ease: "power2.inOut",
        onComplete: () => {
          gsap.set(masks[previousIndex], { clipPath: outgoingEnd });
        },
      });
    };
  };

  const splitScreenSlid = () => {
    document.querySelectorAll(".featured-products-section").forEach((item) => {
      if (item.classList.contains("slider_started")) {
        return;
      }

      item.classList.add("slider_started");

      const id = item.id;
      const box = item.querySelector(".product-slider");

      const autoplay = box.dataset.autoplay === "false" ? false : true;
      const stopAutoplay = box.dataset.stopAutoplay === "false" ? false : true;
      const loop = box.dataset.loop === "false" ? false : true;
      const delay = Number(box.dataset.delay) * 1000;

      let autoplayParm = {};

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay,
            disableOnInteraction: false,
          },
        };
      }

      const swiperParms = {
        effect: box.dataset.effect,
        speed: 1000,
        keyboard: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
        creativeEffect: {
          prev: {
            shadow: false,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        flipEffect: {
          slideShadows: false,
        },
        ...autoplayParm,
      };

      const swiperText = new Swiper(`#${id} .product-slider__product-swiper`, {
        navigation: {
          nextEl: `#${id} .slider-nav-button--next`,
          prevEl: `#${id} .slider-nav-button--prev`,
        },
        loop,
        ...swiperParms,
        spaceBetween: 12,
      });

      setupStaticContent(item);
      setupImageMasks(item);
      const runImageReveal = initImageRevealAnimation(
        item,
        swiperText.realIndex
      );

      let previousRealIndex = swiperText.realIndex;

      swiperText.on("slideChangeTransitionStart", () => {
        const activeRealIndex = swiperText.realIndex;
        if (activeRealIndex === previousRealIndex) {
          return;
        }

        const moveForward = isForwardTransition({
          swipeDirection: swiperText.swipeDirection,
          activeIndex: activeRealIndex,
          previousIndex: previousRealIndex,
          totalSlides: item.querySelectorAll(
            ".product-slider__image-swiper .swiper-slide"
          ).length,
        });

        runImageReveal?.({
          activeIndex: activeRealIndex,
          previousIndex: previousRealIndex,
          moveForward,
        });

        previousRealIndex = activeRealIndex;
      });

      if (autoplay && stopAutoplay) {
        const wrapper = document.querySelector(
          `#${id} .product-slider__wrapper`
        );

        wrapper?.addEventListener("mouseenter", () => {
          swiperText.autoplay.stop();
        });

        wrapper?.addEventListener("mouseleave", () => {
          swiperText.autoplay.start();
        });
      }

      if (item.querySelectorAll(".observe-me").length > 0) {
        const handleIntersect = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const classList = entry.target.classList;

              classList.add("is-inview");

              if (autoplay) {
                swiperText.autoplay.stop();
              }

              observer.unobserve(entry.target);

              setTimeout(() => {
                classList.remove("is-inview");
                classList.remove("observe-me");

                if (autoplay) {
                  swiperText.autoplay.start();
                }
              }, 600);
            }
          });
        };

        const observer = new IntersectionObserver(handleIntersect, {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        });

        item.querySelectorAll(".observe-me").forEach((target) => {
          observer.observe(target);
        });
      }
    });
  };

  splitScreenSlid();

  document.addEventListener("DOMContentLoaded", () => {
    splitScreenSlid();
  });

  document.addEventListener("shopify:section:load", () => {
    splitScreenSlid();
  });
})();
